import React from 'react';

import CMSContent from '../CMSContent/index.jsx';


class Grid extends React.Component {
  render() {
    return (
      <div className="cs-block-grid">
        <div className="cs-block-grid__container">
          {this.props.children}
        </div>
      </div>
    );
  }
}


class Column extends React.Component {
  render() {
    return (
      <div className="cs-block-grid__column">
        <CMSContent variants="template">
          {this.props.children}
        </CMSContent>
      </div>
    );
  };
}


export default Grid;

export { Column };

